import * as types from './unitActionTypes';

export const getUnitRequestAction = (payload) => ({
  type: types.GET_UNIT_REQUEST,
  payload,
});

export const getUnitDataAction = (payload) => ({
  type: types.GET_UNIT_DATA,
  payload,
});

export const getUnitErrorAction = (payload) => ({
  type: types.GET_UNIT_ERROR,
  payload,
});

export const createUnitRequestAction = (payload) => ({
  type: types.CREATE_UNIT_REQUEST,
  payload,
});

export const createUnitDataAction = (payload) => ({
  type: types.CREATE_UNIT_DATA,
  payload,
});

export const createUnitErrorAction = (payload) => ({
  type: types.CREATE_UNIT_ERROR,
  payload,
});

export const updateUnitRequestAction = (payload) => ({
  type: types.UPDATE_UNIT_REQUEST,
  payload,
});

export const updateUnitDataAction = (payload) => ({
  type: types.UPDATE_UNIT_DATA,
  payload,
});

export const updateUnitErrorAction = (payload) => ({
  type: types.UPDATE_UNIT_ERROR,
  payload,
});

export const deleteUnitRequestAction = (payload) => ({
  type: types.DELETE_UNIT_REQUEST,
  payload,
});

export const deleteUnitDataAction = (payload) => ({
  type: types.DELETE_UNIT_DATA,
  payload,
});

export const deleteUnitErrorAction = (payload) => ({
  type: types.DELETE_UNIT_ERROR,
  payload,
});
